import { Box, Chip } from "@mui/material";

export type ImporterTogglesProps = {
  options: string[];
  value: string[];
  onChange: (next: string[]) => void;
};

export const ImporterToggles = ({
  options,
  value,
  onChange,
}: ImporterTogglesProps) => {
  if (options.length === 0) return null;
  const toggle = (name: string) => {
    if (value.includes(name)) {
      onChange(value.filter((v) => v !== name));
    } else {
      onChange([...value, name]);
    }
  };
  return (
    <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
      {options.map((name) => {
        const selected = value.includes(name);
        return (
          <Chip
            key={name}
            size="small"
            label={name}
            color={selected ? "primary" : "default"}
            variant={selected ? "filled" : "outlined"}
            onClick={() => toggle(name)}
            sx={{ opacity: selected ? 1 : 0.75 }}
          />
        );
      })}
    </Box>
  );
};
